
export const setNavbarVisible = () => {
    return {
        type: 'QBO_CONNECTED'
    }
}

export const setNavbarInVisible = () => {
    return {
        type: 'QBO_DISCONNECTED'
    }
}

export const SetJwtToken = (data) => {
    return {
        type: 'SET_JWT_TOKEN',
        payload: data,
    }
}

export const removeJwtToken = (data) => {
    return {
        type: 'REMOVE_JWT_TOKEN',
        payload: data,
    }
}

export const setCompanyDetails = (data) => {
    return {
        type: 'SET_COMPANY_DETAILS',
        payload: data,
    }
}